<template>
  <span>{{ rub }}</span>
</template>

<script>

const SHOW_KOP_ALWAYS = 'always';
export const SHOW_KOP_AUTO = 'auto';
const SHOW_KOP_HIDE = 'hide';

/**
 * @description Компонент представления копеек в рублях.
 * @type {any}
 */
export default {
  computed: {
    rub() {
      const kop = this.format(this.round(this.kop));
      return this.currency
        ? `${kop} ${this.currency}`
        : kop;
    },
  },
  methods: {
    round(value) {
      const round = Math.round(value || 0);
      return (round / 100).toFixed(2);
    },
    format(value) {
      const parts = value.toString().split('.');
      const rub = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      if (this.showKop === SHOW_KOP_HIDE) {
        return rub;
      }
      const kop = parts[1];
      if (this.showKop === SHOW_KOP_AUTO) {
        if (kop === '00') {
          return rub;
        }
      }
      return [rub, kop].join('.');
    },
  },
  props: {
    showKop: { default: () => SHOW_KOP_ALWAYS, type: String },
    /**
     * @description Копейки.
     * @type {number}
     */
    kop: { type: Number, required: true },
    /**
     * @description Валюта.
     * @type {string}
     */
    currency: { type: String, default: () => '' },
  },
};
</script>
